import { BaseTextSelectionMenu } from "./BaseTextSelectionMenu";

export * from "./BaseTextSelectionMenu.style";

export default BaseTextSelectionMenu;
